import { ajaxListOportunidades } from '../functions/ajax-settings.js';


document.addEventListener("DOMContentLoaded", () => {

    ajaxListOportunidades();

});
